import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18RetryG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M7.5 1.227a.56.56 0 0 0 .056.743l1.025.99-.171.011a7.1 7.1 0 0 0-3.527 1.272C3.371 5.307 2.377 6.879 2.086 8.668c-.6 3.692 2.016 7.166 5.828 7.746q.544.084 1.09.083c3.418 0 6.373-2.419 6.91-5.72.398-2.438-.608-4.894-2.623-6.41a.583.583 0 0 0-.803.1.56.56 0 0 0 .102.8c1.68 1.262 2.516 3.305 2.186 5.33-.5 3.072-3.498 5.18-6.686 4.699-3.184-.485-5.364-3.38-4.865-6.45.242-1.487 1.069-2.795 2.33-3.683l.21-.14a5.94 5.94 0 0 1 2.802-.93l.122-.006-1.133 1.095a.56.56 0 0 0 0 .807.58.58 0 0 0 .81 0l2.218-2.144a.374.374 0 0 0 .009-.53L8.365 1.163a.584.584 0 0 0-.809 0l-.057.064z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18RetryG$1 = Svg18RetryG;

export { Svg18RetryG$1 as default };
